import React from 'react';
import { useLocation } from 'react-router-dom';
import { logo } from 'utils/importFile';
import { Background, AnimationCommon } from '..';
interface AuthLayoutProps {
  children: React.ReactNode;
}
const AuthLayout = ({ children }: AuthLayoutProps) => {
  const location = useLocation();

  return (
    <>
      <Background>
        <AnimationCommon
          effect='fadeDown'
          transition='slow'
          presenceMode='wait'
          presenceKey={location.pathname}
          disablePresence={false}
          className='flex items-center justify-center h-screen'
        >
          <div className='bg-[var(--bgWhite50)] p-[24px] rounded-[16px] w-[468px] gap-[10px]'>
            <div className='p-[24px] rounded-[16px] w-[420px] gap-[24px] flex flex-col'>
              <div className='text-center'>
                <img src={logo} alt='Logo' className='mx-auto w-[108px] h-[108px]' />
              </div>
              {children}
            </div>
          </div>
        </AnimationCommon>
      </Background>
    </>
  );
};

export default AuthLayout;
